import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchReplenishmentOrders = createAsyncThunk("fetchReplenishmentOrders", async ({ page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 20,
        distributorCode: filters?.distributorCode || "",
        dateFrom: filters?.dateFrom || "",
        dateTo: filters?.dateTo || "",
    });

    const response = await axiosHttp.get(`replenishment/orders?${params}`);
    return response.data;
});

const ReplenishmentOrdersSlice = createSlice({
    name: "ReplenishmentOrdersSlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
        total: 0,
        page: 1,
        limit: 20,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchReplenishmentOrders.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchReplenishmentOrders.fulfilled, (state, action) => {
            state.isLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.data = Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []);

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.total = total;

            state.page = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 20)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchReplenishmentOrders.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });
    },
});

export default ReplenishmentOrdersSlice.reducer;
